import React from "react";
import HighchartsComponent from "@ui/Highcharts";
import useOptions from "./useOptions";
import type { SelectedQuantity } from "../../useSelectedQuantities";
import type getSeries from "./getSeries";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";
import type { Project } from "../../../../api/useProjects";
import type { Source } from "../../../../api/useSources";

interface P {
  chartRef: React.RefObject<Highcharts.Chart>;
  analyses: ActiveAnalysis[];
  project: Project;
  source: Source;
  timeZone: string;
  selectedQuantities: SelectedQuantity[];
  series: ReturnType<typeof getSeries>;
}

const Gap = ({ chartRef, analyses, project, source, selectedQuantities, series, timeZone }: P) => {
  const options = useOptions({
    chartRef,
    selectedQuantities,
    series,
    analyses,
    project,
    source,
    timeZone,
  });

  return (
    <HighchartsComponent
      name="Symptoms gap"
      ref={chartRef}
      options={options}
      normalizeNavigatorSeries
      selectablePoints={false}
      timezone={timeZone}
    />
  );
};

export default React.memo(Gap);
